import React from 'react';
import { isMobile } from 'react-device-detect';
import { useHistory } from 'react-router-dom';
import sanitizeHtml from 'sanitize-html';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import route from '@src/constants/route';
import { StyledViewReason } from './index.style';

const ViewReason = ({
  open,
  note,
  onClose,
  handleRecordAgain,
  isShowContact,
  handleClickGenerateVoice,
}) => {
  const history = useHistory();
  const { t } = useTranslation();

  const handleCreateNewVoice = () => {
    onClose();
    if (isMobile) {
      history.push(route.VOICE_CLONING_CREATE);
      return;
    }
    handleClickGenerateVoice();
  };

  return (
    <StyledViewReason open={open}>
      <DialogTitle classes={{ root: 'dialog-title' }}>
        <Typography className="title">{t('reason')}</Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          color="secondary"
          className="close-button"
        >
          <Close color="secondary" />
        </IconButton>
      </DialogTitle>
      <DialogContent classes={{ root: 'dialog-content' }}>
        <Typography className="reason">{note}</Typography>
        {isShowContact && (
          <div
            className="contact"
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(t('reasonContactInfo')),
            }}
          />
        )}
      </DialogContent>
      <DialogActions classes={{ root: 'dialog-actions' }}>
        {isShowContact ? (
          <Box display="flex" width="100%" gap="8px">
            <Button
              variant="outlined"
              fullWidth
              className="button"
              onClick={onClose}
            >
              {t('understand')}
            </Button>
            <Button
              variant="contained"
              fullWidth
              className="button"
              onClick={handleCreateNewVoice}
            >
              {t('createNew')}
            </Button>
          </Box>
        ) : (
          <Button
            variant="contained"
            fullWidth
            className="button"
            onClick={handleRecordAgain}
          >
            {t('recordAgain')}
          </Button>
        )}
      </DialogActions>
    </StyledViewReason>
  );
};

export default ViewReason;
